//
// menuItems.tsx 
// 

import React from "react";

import ModeEditIcon from "@mui/icons-material/ModeEdit";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import VideoCameraFrontOutlinedIcon from "@mui/icons-material/VideoCameraFrontOutlined";

import { localStoreService } from "_services/localStoreService";

const getMenuItems = (props: any) => {
  const { intl } = props;

  const path = window.location.href;
  const isSignDoc = path.includes("/signdoc");

  if (isSignDoc) {
    // clean local data
    localStoreService.removeData();
    // display logout menu for sign doc sessions
    return [
      { divider: true },
      {
        value: "/Logout",
        visible: true,
        primaryText: intl.formatMessage({
          id: "menu_sign_out_id",
          defaultMessage: "Sign Out ",
        }),
        leftIcon: <VpnKeyIcon />,
      },
    ];
  }

  const data = localStoreService.retrieveData();

  // If user is unauthenticated or on public authentication routes, do not display internal menu items
  const isAuthPage =
    path.includes("/signin") ||
    path.includes("/signup") ||
    path.includes("/password_reset") ||
    path.includes("/logout");

  if (!data || !data.userdata || isAuthPage) {
    return [];
  }

  const homeIndex = path.indexOf("/home");
  const totalLength = path.length;
  let isHome = false;

  if (homeIndex !== -1 && totalLength - homeIndex === 5) {
    isHome = true;
  }

  if (isHome) {
    // home page
    return [
      {
        value: "/home",
        visible: true,
        primaryText: intl.formatMessage({
          id: "menu_sign_doc_id",
          defaultMessage: "Sign Document",
        }),
        leftIcon: <ModeEditIcon />,
      },

      { divider: true },

      {
        value: "/Logout",
        visible: true,
        primaryText: intl.formatMessage({
          id: "menu_sign_out_id",
          defaultMessage: "Sign Out ",
        }),
        leftIcon: <VpnKeyIcon />,
      },
    ];
  } else {
    // non signing page
    return [
      {
        value: "/home/jobsmanager",
        visible: true,
        primaryText: "Our Services",
        leftIcon: <FolderOpenIcon />,
      },

      {
        value: "/home/paymentmanager",
        visible: true,
        primaryText: intl.formatMessage({
          id: "menu_payment_id",
          defaultMessage: "Payment",
        }),
        leftIcon: <AttachMoneyIcon />,
      },

      {
        value: "/home/myaccount",
        visible: true,
        primaryText: intl.formatMessage({
          id: "menu_account_id",
          defaultMessage: "Account",
        }),
        leftIcon: <AccountCircleIcon />,
      },

      {
        value: "/videoconference",
        visible: true,
        primaryText: intl.formatMessage({
          id: "menu_videoconference_id",
          defaultMessage: "Video Conf.",
        }),
        leftIcon: <VideoCameraFrontOutlinedIcon />,
      },

      { divider: true },

      {
        value: "/Logout",
        visible: true,
        primaryText: intl.formatMessage({
          id: "menu_sign_out_id",
          defaultMessage: "Sign Out ",
        }),
        leftIcon: <VpnKeyIcon />,
      },
    ];
  }
};

export default getMenuItems;
